export const strategies = [
  {
    id: 'scalping',
    name: 'EMA Cross 9/20',
    tagline: 'Cruzamento das médias móveis exponenciais 9 e 20 períodos',
    category: 'Curto/Médio Prazo',
    timeframe: 'M5 / M15 / H1',
    risk: 'Médio',
    difficulty: 'Iniciante-Intermédio',
    image: 'https://public.readdy.ai/ai/img_res/0a4ec7a392201ef6332c4e29dd6cb076.jpg',
    description: 'A estratégia EMA Cross 9/20 baseia-se no cruzamento das médias móveis exponenciais de 9 e 20 períodos para identificar mudanças de tendência e pontos de entrada com alta probabilidade. Quando a EMA 9 cruza acima da EMA 20, temos um sinal de compra (Golden Cross). Quando cruza abaixo, temos um sinal de venda (Death Cross). É uma das estratégias mais acessíveis e utilizadas tanto por iniciantes como por traders profissionais, pela sua clareza visual e adaptabilidade a diferentes mercados e timeframes.',
    pros: [
      'Sinais visuais claros — entrada e saída bem definidas',
      'Fácil de aprender e aplicar em qualquer mercado de futuros',
      'Funciona em múltiplos timeframes (M5, M15, H1)',
      'Filtra o ruído do mercado melhor que médias simples (SMA)',
      'Combinável com RSI, volume ou suporte/resistência para confirmação',
      'Compatível com todas as prop firms sem restrições',
    ],
    cons: [
      'Indicador lagging — sinal aparece após o início do movimento',
      'Muitos falsos cruzamentos em mercados laterais (ranging)',
      'Requer confirmação de tendência em timeframe superior',
      'Não adequado para mercados com baixa volatilidade',
    ],
    bestFor: 'Traders iniciantes e intermédios que operam intraday em futuros (ES, NQ, CL)',
    propFirmCompatibility: 'Alta — totalmente compatível com todas as prop firms. Sem restrições de estilo de trading. Ideal para cumprir regras de consistency rule.',
    winRate: '50-60%',
    riskReward: '1:2 a 1:3',
    indicators: ['EMA 9', 'EMA 20', 'Volume', 'RSI 14'],
  },
  {
    id: 'day-trading',
    name: 'EMA 200 Bounce',
    tagline: 'Um setup simples, em qualquer mercado — o Método da EMA 200',
    category: 'Todos os Mercados',
    timeframe: 'M30 / H1 / H4 / D1',
    risk: 'Baixo-Médio',
    difficulty: 'Iniciante',
    image: 'https://readdy.ai/api/search-image?query=EMA%20200%20exponential%20moving%20average%20bounce%20price%20retest%20trading%20strategy%20chart%20candlestick%20support%20dynamic%20level%20financial%20markets%20professional%20dark%20blue%20clean&width=800&height=500&seq=s2&orientation=landscape',
    description: 'A estratégia EMA 200 Bounce é considerada um dos setups mais simples e eficazes já testados — funciona em qualquer mercado e em qualquer timeframe. O conceito é direto: a EMA 200 atua como uma zona de suporte ou resistência dinâmica extremamente respeitada. Quando o preço se afasta da EMA 200 e regressa para a tocar (bounce/retest), surge uma oportunidade de entrada a favor da tendência principal.',
    pros: [
      'Funciona em qualquer mercado — futuros, forex, ações, cripto',
      'Aplicável em qualquer timeframe (M30 a Diário)',
      'Setup visualmente claro — fácil de identificar',
      'Opera sempre a favor da tendência principal',
      'Ideal para principiantes sem experiência técnica',
      'Risco bem definido — stop loss natural abaixo/acima da EMA 200',
      'Totalmente compatível com todas as prop firms',
    ],
    cons: [
      'Precisa de mercado em tendência clara — não funciona em ranging',
      'A EMA 200 é um indicador lagging (atrasado)',
      'Pode demorar muito tempo a surgir o setup ideal',
      'Requer paciência para aguardar o reteste à EMA',
      'Em timeframes muito baixos gera mais ruído',
    ],
    bestFor: 'Iniciantes e traders que querem um método simples, consistente e aplicável a qualquer mercado sem complexidade',
    propFirmCompatibility: 'Alta — sem restrições. Compatível com FTMO, Topstep, Apex, MyFundedFutures e todas as principais prop firms. Ideal para passar avaliações com consistência.',
    winRate: '55-65%',
    riskReward: '1:2 a 1:4',
    indicators: ['EMA 200', 'Velas de Confirmação', 'Volume', 'Suporte/Resistência'],
  },
  {
    id: 'swing-trading',
    name: 'Estratégia 1H Candle',
    tagline: 'O padrão de 1H que ninguém fala — entrada precisa no gráfico de 1 minuto',
    category: 'Intraday',
    timeframe: 'H1 (setup) + M1 (entrada)',
    risk: 'Baixo-Médio',
    difficulty: 'Iniciante',
    image: 'https://readdy.ai/api/search-image?query=1%20hour%20candle%20pattern%20trading%20strategy%20price%20action%20hourly%20chart%20candlestick%20formation%20high%20low%20break%20financial%20markets%20dark%20blue%20professional%20clean%20simple&width=800&height=500&seq=s3&orientation=landscape',
    description: 'A Estratégia 1H Candle é um dos setups de price action mais simples e menos conhecidos do mercado intraday. A estratégia usa o gráfico de 1 hora para identificar o padrão e desce ao gráfico de 1 minuto para uma entrada ultra-precisa com stop loss mínimo. Sem indicadores, sem complexidade — apenas price action puro.',
    pros: [
      'Sem indicadores — price action puro, sem distrações',
      'Stop loss extremamente pequeno (menos de meia vela)',
      'Setup claro e objetivo no gráfico de 1H',
      'Entrada precisa no M1 para maximizar risco/retorno',
      'Funciona em futuros, forex e ações',
      'Ideal para contas pequenas e regras de prop firms',
      'Backtestável facilmente em qualquer plataforma',
    ],
    cons: [
      'Requer monitorização ativa durante a sessão',
      'Precisa de prática para reconhecer o padrão corretamente',
      'Poucos setups por dia — requer paciência',
      'A entrada no M1 exige rapidez e decisão',
    ],
    bestFor: 'Iniciantes que querem uma estratégia simples e objetiva, sem indicadores, com risco controlado',
    propFirmCompatibility: 'Alta — stop loss pequeno e risco controlado são ideais para regras de prop firms. Sem overnight, sem notícias. Perfeitamente compatível com FTMO, Topstep e Apex.',
    winRate: '55-65%',
    riskReward: '1:2 a 1:5',
    indicators: ['Price Action', 'Velas de 1H', 'Gráfico de 1M', 'Highs e Lows'],
  },
  {
    id: 'breakout',
    name: 'Impulse Entry',
    tagline: 'Entrada no impulso após pullback — price action puro e objetivo',
    category: 'Price Action',
    timeframe: 'M30 / H1 / H4',
    risk: 'Médio',
    difficulty: 'Intermédio',
    image: 'https://readdy.ai/api/search-image?query=impulse%20entry%20trading%20strategy%20price%20action%20breakout%20after%20pullback%20retracement%20bullish%20momentum%20candle%20professional%20dark%20blue%20financial%20chart%20clean%20elegant&width=800&height=500&seq=s4&orientation=landscape',
    description: 'A Impulse Entry baseia-se numa lógica simples e poderosa: o mercado move-se em impulsos seguidos de pullbacks. O objetivo é identificar um movimento impulsivo forte (no H4, H1 ou M30), aguardar o pullback natural de retração, e entrar precisamente quando o preço retoma o impulso original. Stop loss abaixo do low do pullback, target de 50% do range do movimento anterior — simples, objetivo e muito eficaz especialmente na abertura de Nova Iorque.',
    pros: [
      'Lógica simples baseada em como o mercado realmente se move',
      'Stop loss muito bem definido — abaixo do low do pullback',
      'Funciona especialmente bem na abertura de Nova Iorque (NY Open)',
      'Risco/retorno favorável com target de 50% do range anterior',
      'Aplicável em M30, H1 e H4 — flexibilidade de timeframe',
      'Sem indicadores complexos — price action puro',
      'Totalmente compatível com regras de prop firms',
    ],
    cons: [
      'Requer identificar corretamente o impulso vs. movimento aleatório',
      'Pullbacks muito profundos podem invalidar o setup',
      'Menos setups em mercados de baixa volatilidade',
      'Precisa de contexto de tendência para funcionar bem',
    ],
    bestFor: 'Traders intermédios que percebem estrutura de mercado e querem uma entrada precisa com risco definido em movimentos impulsivos',
    propFirmCompatibility: 'Alta — stop loss preciso e target definido são ideais para cumprir regras de drawdown das prop firms. Funciona muito bem no NY Open, a sessão mais compatível com avaliações.',
    winRate: '55-65%',
    riskReward: '1:2 a 1:3',
    indicators: ['Price Action', 'Range do Impulso', 'Pullback Low/High', 'Sessão NY Open'],
  },
  {
    id: 'orderflow',
    name: 'VWAP Strategy',
    tagline: 'O nível que bancos e algoritmos nunca ignoram — Volume Weighted Average Price',
    category: 'Intraday',
    timeframe: 'M1 / M5 / M15',
    risk: 'Baixo-Médio',
    difficulty: 'Iniciante-Intermédio',
    image: 'https://readdy.ai/api/search-image?query=VWAP%20volume%20weighted%20average%20price%20intraday%20trading%20strategy%20chart%20candlestick%20institutional%20level%20professional%20dark%20blue%20financial%20clean%20price%20line%20volume&width=800&height=500&seq=s5vwap&orientation=landscape',
    description: 'O VWAP (Volume Weighted Average Price) é o indicador mais utilizado por traders institucionais, bancos, algoritmos e fundos de investimento em todo o mundo. É calculado automaticamente em qualquer plataforma de trading e representa o preço médio ponderado pelo volume durante o dia. A estratégia é simples: o VWAP funciona como uma zona de suporte e resistência dinâmica de altíssima relevância — quando o preço a testa e ressalta, tens um dos setups intraday de maior probabilidade. Sem complexidade, sem indicadores especulativos. Apenas preço, volume e o nível que todos os players institucionais observam.',
    pros: [
      'Usado por bancos, fundos e algoritmos — nível com peso real no mercado',
      'Disponível gratuitamente em todas as plataformas (TradingView, NinjaTrader, etc.)',
      'Setup visual e objetivo — fácil de identificar em qualquer gráfico',
      'Funciona especialmente bem em futuros e ações de alta liquidez',
      'Ideal para scalping e day trading intraday',
      'Stop loss natural e bem definido abaixo/acima do VWAP',
      'Sem necessidade de indicadores adicionais para a entrada básica',
    ],
    cons: [
      'Reset diário — o VWAP começa de zero em cada sessão',
      'Menos eficaz em dias de baixo volume ou mercados ilíquidos',
      'Não funciona bem para swing trading ou posições overnight',
      'Em dias de tendência forte, o preço pode afastar-se muito do VWAP sem regressar',
      'Requer gestão ativa do trade durante a sessão',
    ],
    bestFor: 'Day traders e scalpers que operam futuros (ES, NQ, CL) ou ações de alta liquidez durante as sessões de Londres e Nova Iorque, com foco em setups institucionais de alto volume',
    propFirmCompatibility: 'Alta — estratégia puramente intraday sem posições overnight, compatível com todas as principais prop firms (FTMO, Topstep, Apex). O stop loss bem definido e o risco controlado são ideais para cumprir regras de drawdown diário.',
    winRate: '55-65%',
    riskReward: '1:2 a 1:3',
    indicators: ['VWAP', 'VWAP SD+1 / SD-1', 'VWAP SD+2 / SD-2', 'Volume', 'Velas de Confirmação'],
  },
  {
    id: 'trend-following',
    name: 'Higher High / Lower Low',
    tagline: 'Estrutura de mercado pura — opera onde o dinheiro realmente se move',
    category: 'Price Action',
    timeframe: 'M15 / H1 / H4',
    risk: 'Baixo-Médio',
    difficulty: 'Iniciante-Intermédio',
    image: 'https://readdy.ai/api/search-image?query=higher%20high%20lower%20low%20market%20structure%20price%20action%20trading%20chart%20swing%20points%20uptrend%20downtrend%20professional%20dark%20blue%20financial%20clean%20technical%20analysis&width=800&height=500&seq=s6&orientation=landscape',
    description: 'A estratégia Higher High / Lower Low (HH/LL) é a base de toda a análise técnica — é literalmente como o mercado se move. Em tendência de alta, o preço faz Higher Highs e Higher Lows. Em tendência de baixa, faz Lower Highs e Lower Lows. Operar com base nesta estrutura significa entrar exatamente onde o mercado confirma a sua direção — sem indicadores, sem sinais atrasados.',
    pros: [
      'Sem indicadores — leitura direta da estrutura do mercado',
      'Funciona em qualquer mercado e timeframe',
      'Stop loss natural nos swing lows/highs de estrutura',
      'Identifica mudanças de tendência antes dos indicadores',
      'Base de qualquer outra estratégia — essencial conhecer',
      'Altíssima compatibilidade com todas as prop firms',
    ],
    cons: [
      'Requer treino para identificar corretamente os swing points',
      'Mercados laterais geram estruturas confusas',
      'Subjetivo — dois traders podem ver estruturas diferentes',
      'Requer paciência para aguardar confirmação da estrutura',
    ],
    bestFor: 'Traders que querem entender o mercado em profundidade e construir uma base sólida de price action antes de qualquer outra estratégia',
    propFirmCompatibility: 'Alta — estratégia baseada em estrutura de mercado, sem restrições. Ideal para prop firms pois os alvos são claros e o risco é bem definido. Compatível com FTMO, Topstep, Apex e todas as principais.',
    winRate: '55-65%',
    riskReward: '1:2 a 1:4',
    indicators: ['Swing Highs/Lows', 'EMA 20', 'EMA 50', 'EMA 200', 'BOS / CHoCH'],
  },
];
